import {
  PERCENT_NUMBER_FORMAT,
  TOTAL_NUMBER_FORMAT,
  applyGridStyle,
  applyRangeFormats,
  rangeFormatting,
} from "../../styles/worksheet";
import { safeWorksheetName } from "../../workbook";
import { dateStampSheet } from "../helpers/dynamicSheets";
import { columnNames, rowNames } from "../helpers/rangeNames";
import { generateMarkupsReport } from "../markups";
import { titleMaker } from "./common";

export const createMarkupsTemplate = async () => {
  try {
    return Excel.run(async (context) => {
      const workbook = context.workbook;
      const reportTitle = "Markups";
      const insertRowName = rowNames.markups;
      const safeName = await safeWorksheetName(workbook, reportTitle);
      const sheet = workbook.worksheets.add(safeName);
      await context.sync();

      await titleMaker(sheet, reportTitle);
      const rowHeights = [15, 30, 25, 25];
      rowHeights.forEach((height, index) => {
        sheet.getRange(`${index + 5}:${index + 5}`).format.rowHeight = height;
      });

      const columnWidths = [20, 400, 70, 120, 20, 100];
      columnWidths.forEach((width, index) => {
        sheet.getRange(`${String.fromCharCode(65 + index)}:${String.fromCharCode(65 + index)}`).format.columnWidth =
          width;
      });

      sheet.getRange("1:7").format.verticalAlignment = Excel.VerticalAlignment.center;
      await context.sync();

      const headers: rangeFormatting[] = [
        { rangeAddress: "B6", value: "Name", name: "\\name", Halignment: "Left" },
        { rangeAddress: "C6", value: "Quantity", name: "\\quantity", Halignment: "Center" },
        { rangeAddress: "D6", value: "Total", name: "\\total", Halignment: "Right" },
        { rangeAddress: "F6", name: `\\${columnNames.useGroups}`, Halignment: "Center" },
      ];
      headers.forEach((header) => {
        header.fontSize = 12;
        header.bold = true;
      });
      applyRangeFormats(sheet, headers);

      const dataRows: rangeFormatting[] = [
        { rangeAddress: "B7", name: insertRowName },
        { rangeAddress: "C7", numberFormat: PERCENT_NUMBER_FORMAT, Halignment: "Right" },
        { rangeAddress: "D7", numberFormat: TOTAL_NUMBER_FORMAT, Halignment: "Right" },
        { rangeAddress: "F7", numberFormat: TOTAL_NUMBER_FORMAT, Halignment: "Right" },
      ];
      applyRangeFormats(sheet, dataRows);

      await dateStampSheet(sheet);
      applyGridStyle({ range: sheet.getRange("B6:D6"), borderColor: "Black", weight: "Medium", edges: ["EdgeBottom"] });
      applyGridStyle({
        range: sheet.getRange("F6"),
        borderColor: "Black",
        weight: "Medium",
        edges: ["EdgeBottom"],
      });
      await context.sync();
      await generateMarkupsReport(sheet);
      sheet.activate();
      await context.sync();
    });
  } catch (error) {
    throw "Error creating default estimate template: " + error;
  }
};
